import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import endpoints from "../../config/endpoints";
import orderEnum from "../../enums/orderEnum";
import "../../factor.css";
import restApi from "../../services/restApi";

const Bijack = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState<any>({});
  const list = () => {
    const rows: ReactElement[] = [];

    data?.products?.map((orderProduct, index) => {
      rows.push(
        <tr className="invoiceTest">
          <td>{++index}</td>
          <td>{orderProduct?.product?.code}</td>
          <td>{orderProduct?.product?.title}</td>
          <td>{orderProduct?.count}</td>
          <td>{orderProduct?.price}</td>
          <td>{orderProduct?.price * orderProduct?.count}</td>
        </tr>,
      );
    });

    return rows;
  };

  const fetchData = async () => {
    // dispatch(setLoading(true));

    const res = await restApi(endpoints.order.index + id).get();

    setData(res.data);

    // dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <main id="xFac" className="persiaNumber">
      <div id="xGo">بیجک</div>
      <div className="xFc"></div>
      <div className="xFc1"></div>
      <div className="xFcLogo"></div>
      <div className="xFcBottom"></div>

      {/* <?php $data = $this->data->list ?> */}
      <div className="bijakPrint">
        <div className="bijakHeader">
          <div className="logo">Parsian LED|پارسیان</div>
          <div className="orderData">
            <p className="inner">شماره سفارش {data.code}</p>
            <p className="inner">
              شماره بیجک
              {/* <?php echo $data->bijak->number ?> */}
            </p>
            <p className="inner">
              شماره فاکتور
              {/* <?php echo Tools::numberToFa($data->order->invoice)?> */}
            </p>
          </div>
          <div className="inpForPrint persianNumber" id="date">
            تاریخ بیجک :
            {/* <?php echo Date::M2J('Y/m/d', $data->bijak->date)?> */}
          </div>
        </div>
        <div className="packagePrice">ارزش مرسوله : {data.price} تومان</div>
        <div className="sender">
          <div className="address">
            فرستنده : تهران،خیابان ملت،نبش کوچه کاوه،ساختمان قاسمیه،پلاک 1،واحد
            6
          </div>
          <div className="senderData">
            <div className="calls">
              شماره تماس : <span>2191305060</span> / <span>9128802386</span>
            </div>
            <div className="postalCode">
              کد پستی : <span className="persianNumber">1143936544</span>
            </div>
          </div>
        </div>
        <div className="reciever">
          <div className="contactInfo">
            <p className="inner">گیرنده : {data.user?.name}</p>
            <p className="inner persianNumber">
              شماره تماس : {data.user?.phoneNumber}
            </p>
          </div>
          <div className="userAddress">
            آدرس :{" "}
            {`${data?.delivery?.address?.province?.title} - ${data?.delivery?.address?.city?.title} - ${data?.delivery?.address?.description}`}
          </div>
          <div className="sendWith">
            <div className="tt">
              ارسال : <input />
            </div>
            <div className="tt">
              <input className="box" type="number" min="0" value="" /> از{" "}
              <input className="box" min="0" type="number" value="" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Bijack;
